import React from 'react'

const contexts = React.createContext()

export default contexts
